<template>
  <div v-if="doneLoading">

    <div class="row">
      <div class="col-12 floorPlans">
        <h3>{{ $t('admin.floorPlan.overview.floorPlans') }}</h3>
        <table class="table table-striped">
          <thead>
          <th>{{ $t('admin.floorPlan.overview.name') }}</th>
          <th> {{ $t('admin.floorPlan.overview.workflowsPlaced') }}</th>
          <th>{{ $t('ui.options') }}</th>
          <th></th>
          </thead>
          <tbody>
          <tr style="border-bottom:2px solid black;">
            <td><strong>{{ getCompanyName }}</strong></td>

            <td><span :class="getWorkflowPlacement(null).allPlaced ?'all-placed' : '' ">{{
                getWorkflowPlacement(null).placed
              }}/{{ getWorkflowPlacement(null).available }}</span>
            </td>
            <td>
              <template v-if="getFloorplanByDepartment(null)">
                <router-link
                    :to="{path:'/admin/floorplan/'+getFloorplanByDepartment(null).id}" exact>
                  {{ $t('admin.floorPlan.overview.edit') }}
                  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 5L1 5M11 5L7 9M11 5L7 1" stroke="#2A52BE" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>

                </router-link>
              </template>
              <template v-else>
                <router-link :to="{path:'/admin/floorplan/create/factory'}" exact>
                  {{ $t('admin.floorPlan.overview.create') }}
                  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 5L1 5M11 5L7 9M11 5L7 1" stroke="#2A52BE" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>
                </router-link>
              </template>

            </td>
            <td>
              <template v-if="getFloorplanByDepartment(null)">
                <i class="far fa-trash"  style="cursor:pointer" @click="deleteFloorplan(getFloorplanByDepartment(null).id)"></i>
              </template>
            </td>
          </tr>

          <tr v-for="department in getCompanyDepartments">
            <td>{{ department }}</td>
            <td><span :class="getWorkflowPlacement(department).allPlaced ?'all-placed' : '' ">{{
                getWorkflowPlacement(department).placed
              }}/{{ getWorkflowPlacement(department).available }}</span></td>
             <td>
              <template v-if="getFloorplanByDepartment(department)">
                <router-link
                    :to="{path:'/admin/floorplan/'+getFloorplanByDepartment(department).id}" exact>
                  {{ $t('admin.floorPlan.overview.edit') }}
                  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 5L1 5M11 5L7 9M11 5L7 1" stroke="#2A52BE" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>
                </router-link>
                <!--                <i class="fal fa-trash" @click="deleteFloorplan(department)"></i>-->
              </template>
              <template v-else>
                <router-link :to="{path:'/admin/floorplan/create/'+department}" exact>
                  {{ $t('admin.floorPlan.overview.create') }}
                  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 5L1 5M11 5L7 9M11 5L7 1" stroke="#2A52BE" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                  </svg>
                </router-link>
              </template>

            </td>
            <td>
              <template v-if="getFloorplanByDepartment(department)">
                <i class="far fa-trash" style="cursor:pointer" @click="deleteFloorplan(getFloorplanByDepartment(department).id)"></i>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

    </div>
    <!--    <div v-else class="d-flex align-items-center justify-content-center nofloorplan-wrapper">-->
    <!--      <div class="row">-->
    <!--        <div class="col-12">-->
    <!--          <h3>{{ $t('admin.floorPlan.overview.noFloorplanFound') }}</h3>-->
    <!--        </div>-->
    <!--        <div class="col-12 mt-3">-->
    <!--          <router-link :to="{path:'/admin/floorplan/create'}">-->
    <!--            {{ $t('admin.floorPlan.overview.noFloorplanFoundLink') }}-->
    <!--            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
    <!--              <path d="M17 12L7 12M17 12L13 16M17 12L13 8" stroke="#2A52BE" stroke-width="1.5" stroke-linecap="round"-->
    <!--                    stroke-linejoin="round"/>-->
    <!--            </svg>-->
    <!--          </router-link>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--    </div>-->
  </div>

</template>

<script>
// https://codepen.io/scorch/pen/JEKorP
// https://codepen.io/gox/pen/oNgrmpK

// https://github.com/mudin/vue-svg
import {mapGetters} from "vuex";


export default {
  name: "FloorPlanIndex",
  components: {},
  data() {
    return {
      doneLoading: false
    }
  },
  computed: {
    ...mapGetters('users', ['getMe']),
    ...mapGetters('workflows', ['getWorkflowsGrouppedPerDepartment', 'getWorkflowsFromDepartment']),
    ...mapGetters('floorPlans', ['getFloorplanByDepartment', 'getFloorplans', 'getFloorplanById']),
    ...mapGetters('company', ['getCompanyDepartments','getCompanyName']),
  },
  methods: {
    getWorkflowPlacement(department) {
      let workflowLength = this.getFloorplanByDepartment(department) ? JSON.parse(this.getFloorplanByDepartment(department).workflows).length : 0
      let getDepartmentWorkflowLength = this.getWorkflowsFromDepartment(department).length
      return {
        placed: workflowLength,
        available: getDepartmentWorkflowLength,
        allPlaced: workflowLength === getDepartmentWorkflowLength && workflowLength > 0
      }
    },
    async deleteFloorplan(id) {
      let floorPlan = this.getFloorplanById(id)

      let {isConfirmed} = await this.swalDelete(
          this.$t('admin.floorPlan.floorPlan') + ' ' + (!floorPlan.department ? this.getCompanyName : floorPlan.department))
      if (isConfirmed) {
        await this.$store.dispatch('floorPlans/delete', floorPlan.id)
        this.swalToastSuccess(this.$t('ui.deleted'))
      }
    }
  },
  watch: {},
  async created() {
    await this.$store.dispatch('floorPlans/fetchAndAdd', {
      where: [
        ['companyId', '==', this.getMe.claims.companyId]
      ]
    })
    this.doneLoading = true

  },
  mounted() {


  }

}

</script>

<style lang="scss" scoped>
$cerBlue: #2A52BE;

thead {
  background: #E3E9F9

}

.floorPlans {
  padding: 18px;
  border-radius: 8px;
  background: white;
  color: #000000;
}

.nofloorplan-wrapper {
  border-radius: 8px;
  padding: 20px 32px 20px 32px;
  background: #F8F9FA;
  height: 80vh
}

h3 {
  color: #000000;
  display: flex;
  flex-direction: column;

  padding: 0px;
  gap: 4px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

i {
  font-size: 15px;
  //font-weight: 700;
  color: $cerBlue;
}

a {
  font-size: 15px;
  font-weight: 700;
  color: $cerBlue;
}

.all-placed {
  font-weight: 800
}
</style>